module.exports = __webpack_public_path__ + "media/images/flags/nl-a7fdb74e17089394b68cb0a24a8d4dbe.svg";